import React from 'react';
import { useT } from '../../contexts/LocaleContext.jsx';
import '../../styles/partial/Multistream.css';

/**
 * Whether SongShake is receiving the band's stream right now (ENG-763), from
 * `status.feed.live`. Nothing shows until the status has been read, or on a
 * server that hasn't configured multistreaming.
 */
function MultistreamFeedIndicator({ status, className = '' }) {
  const t = useT();
  if (!status?.configured) return null;
  const live = status.feed.live;
  return (
    <span
      className={`multistream-feed-indicator ${live ? 'is-live' : 'is-down'} ${className}`.trim()}
      role="status"
      data-testid="multistream-feed-indicator"
    >
      <span className="multistream-feed-dot" aria-hidden="true" />
      {t(live ? 'multistream.feed.receiving' : 'multistream.feed.notReceiving')}
    </span>
  );
}

export default MultistreamFeedIndicator;
